export default "__VITE_ASSET__c089a80c__"